import Stefan from "@Assets/team-members/Stefan-Ruhl.jpg";
import Kathryn from "@Assets/team-members/Kathryn-Kauffman.jpg";
import Marcelo from "@Assets/team-members/Marcelo-Freire.jpg";
import Indresh from "@Assets/team-members/Indresh-Singh.jpeg";
import Max from "@Assets/team-members/Max-Qian.jpg";
import Mickey from "@Assets/team-members/Mickey-Zheng.jpg";
import Floyd from "@Assets/team-members/Floyd-Dewhirst.jpg";
import Tsute from "@Assets/team-members/Tsute-Chen.jpg";
import Jessica from "@Assets/team-members/Jessica-Welch.jpg";
import Markus from "@Assets/team-members/Markus-Hardt.jpeg";
import Yanhui from "@Assets/team-members/Yanhui-Zhang.jpg";
import William from "@Assets/team-members/William-Lau.jpg";
import Shubham from "@Assets/team-members/Shubham-Deshmukh.jpg";
import Anthony from "@Assets/team-members/Anthony-Vo.jpg";
import Andrew from "@Assets/team-members/Andrew-LaPointe.jpg";
import Rhea from "@Assets/team-members/Rhea-Hinger.jpg";
import Shuv from "@Assets/team-members/Shuvrajyoti-Deb.jpg";
import Nikhil from "@Assets/team-members/Nikhil-Singh.jpg";

const memberInfo = [
  {
    title: "University at Buffalo",
    id: "university-at-buffalo",
    members: [
      {
        imageName: "Stefan-Ruhl.jpg",
        image: Stefan,
        description: `<b>Stefan Ruhl, DDS, Ph.D.</b> Stefan is professor of Oral Biology in the School of Dental Medicine at the University at Buffalo, New York, USA. He is a past President of the Salivary Research Group within the International Association for Dental Research (IADR), in 2015 was named IADR Salivary Researcher of the Year, and in 2020 received the IADR Distinguished Scientist Award in Salivary Research and was elected as fellow of the American Association for the Advancement of Science (AAAS). He has been studying the saliva proteome for over 30 years and served as curator of the HSP database since 2013. In his laboratory, he currently studies the molecular mechanisms of glycan-mediated microbial adhesion to salivary glycoproteins from an evolutionary perspective. <a href="https://www.ruhl-lab.org/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">Lab Website &#x2197;</a>`,
      },
      {
        imageName: "Kathryn-Kauffman.jpg",
        image: Kathryn,
        description:
          "<b>Kathryn Kauffman, Ph.D.</b> Kathryn is an Assistant Professor in the Department of Oral Biology in the School of Dental Medicine at the University at Buffalo in Buffalo, NY, USA. Her research is centered on understanding how viruses shape the ecology and evolution of microbial communities and their ecosystems. The current focus of her group is on determining how bacterial viruses (phages) shape the structure and function of the oral microbiome, and how this in turn impacts oral and systemic health.",
      },
    ],
  },
  {
    title: "J. Craig Venter Institute (JCVI)",
    id: "jcvi",
    members: [
      {
        imageName: "Marcelo-Freire.jpg",
        image: Marcelo,
        description:
          "<b>Marcelo Freire, DDS, Ph.D., DMSc</b> Marcelo is an Associate Professor in the Genomic Medicine and Infectious Disease Department at the J. Craig Venter Institute (JCVI). His laboratory is focused on investigating oral host-microbial interactions impacting health and disease.",
      },
      {
        imageName: "Indresh-Singh.jpeg",
        image: Indresh,
        description:
          "<b>Indresh Singh, MSc</b> Indresh is a Sr. Software Engineer, leading Informatics Core Services (ICS) at the J. Craig Venter Institute (JCVI). His expertise is; high-thoughput computing, genomic data analysis, data visualization, software development, and scalable infrastructure development and deployment in local and cloud environment.",
      },
      {
        imageName: "Max-Qian.jpg",
        image: Max,
        description: `<b>Yu "Max" Qian, Ph.D.</b>	Max is an Associate Professor in the Informatics Department at the J. Craig Venter Institute (JCVI). He specializes in immunology bioinformatics and computational cytometry. Trained in computer science, he developed novel algorithms for computational analysis of transcriptomics, proteomics, and clinical data using machine learning and integrative/deconvolutional analysis.`,
      },
      {
        imageName: "Mickey-Zheng.jpg",
        image: Mickey,
        description:
          "<b>Mickey Zheng, B.S.</b> Mickey is a Software Engineer in the Informatics Department at the J. Craig Venter Institute (JCVI) specializing in full-stack development and data management for the HSP and iDPCC project. Skilled in multiple programming languages, including JavaScript and Python, and experienced with frameworks like Next.js and React.js. Proficient in leveraging AWS and other cloud technologies to support scalable solutions.",
      },
    ],
  },
  {
    title: "Forsyth",
    id: "forsyth",
    members: [
      {
        imageName: "Tsute-Chen.jpg",
        image: Tsute,
        description: `<b>Tsute (George) Chen, Ph.D.</b> As Forsyth's leading bioinformatics expert, George is responsible for analyzing huge amounts of data and transforming it into biologically meaningful information that other scientists can understand and interpret to gain new biological insights. George has also created and is maintaining the <a href="https://www.homd.org/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">Human Oral Microbiome Database</a> Exit Disclaimer and <a href="https://www.momd.org/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">Mouse Oral Microbiome Database</a> Exit Disclaimer together with Floyd on the Amazon cloud AWS platform.`,
      },
      {
        imageName: "Jessica-Welch.jpg",
        image: Jessica,
        description:
          "<b>Jessica Mark Welch, Ph.D.</b> Jessica studies the spatial organization and community composition of the oral microbiota. She is a contributor to the Human Oral Microbiome Database (HOMD) and is interested in integration of the Human Salivary Proteome with the HOMD. She is an Associate Scientist at the Marine Biological Laboratory in Woods Hole, Massachusetts.",
      },
      {
        imageName: "Markus-Hardt.jpeg",
        image: Markus,
        description:
          "<b>Markus Hardt, Ph.D.</b> Markus studies the molecular mechanisms underlying physiological and pathological processes through the lens of mass spectrometry. Through global analyses of proteomes, peptidomes and metabolomes in conjunction with functional studies, his laboratory is investigating the modulation of the immune response by post-translational modifications and proteolytic processing. The highly interdisciplinary and collaborative research includes projects on the oral microbiome, salivary proteome, cancer pain, Sjögren’s syndrome, periodontitis, obesity and COVID19 with the overall goal to foster the translation of biochemical understanding into improved diagnostics and therapeutics.",
      },
    ],
  },
  {
    title: "The University of Tennessee Health Science Center",
    id: "the-university-of-tennessee-health-science-center",
    members: [
      {
        imageName: "Yanhui-Zhang.jpg",
        image: Yanhui,
        description:
          "<b>Yanhui Zhang, B.S., M.S., Ph.D.</b> Yanhui is an Associate professor at the Department of Bioscience Research, College of Dentistry, The University of Tennessee Health Science Center. Her research spans three areas: Tetraspanins in oral biology and cancer; Clinical and translational research of biocompatibility and efficacy of oral care devices and therapeutics; Saliva, sputum, dental plaque, and oral cells/tissues metabolomics, proteomics, and microbiome in oral and systemic diseases; She will continue to work with the HSP and HOMD team to maintain, develop and upgrade the HSP database to serve scientific communities.",
      },
    ],
  },
  {
    title: "Founding Members",
    id: "founding-members",
    members: [
      {
        imageName: "William-Lau.jpg",
        image: William,
        description:
          "<b>William Lau, B.S., M.S., Ph.D.</b> William Lau has been a bioinformatics scientist/staff computer engineer and group leader at the National Institutes of Health (NIH) since 2005.  He obtained both of his BS and MS in Biomedical Engineering, and a doctorate in Bioinformatics.  He has a strong track record of working across disciplines and with both computational and experimental biologists to develop and apply quantitative methods to answer research questions.  He has also led the development of several biomedical database systems and web applications for use by NIH researchers as well as the broader scientific community. His current research focuses on using systems biology approaches to unravel the intricacies of the immune system network, resulting in multiple publications as co-first author in high impact journals.   William has received the NIH Director’s Award and several CIT/NIAID Merit Awards for his contributions to the NIH’s missions.",
      },
      {
        imageName: "Floyd-Dewhirst.jpg",
        image: Floyd,
        description: `<b>Floyd E. Dewhirst, DDS, Ph.D.</b> Floyd has been a research scientist at The Forsyth Institute where he has been continuously funded by NIDCR for the past 43 years. He is known for his work on organisms comprising the human oral microbiome and the creation of the <a href="https://www.homd.org/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">Human Oral Microbiome Database</a>  Exit Disclaimer. His current research focuses on culturing as-yet-uncultured bacteria, determining their genome sequences and understanding their role in human health and disease.`,
      },
    ],
  },
  {
    title: "Past Interns",
    id: "past-interns",
    members: [
      {
        imageName: "Andrew-LaPointe.jpg",
        image: Andrew,
        description:
          "<b>Andrew LaPointe</b> Andrew LaPointe is a student of Computer Science and software engineering. His skills include full-stack web development, D3, and scripting. Past projects include Erlang OTP, Express JS, and, Python applications.",
      },
      {
        imageName: "Anthony-Vo.jpg",
        image: Anthony,
        description:
          "<b>Anthony Vo, B.S.</b> Anthony has a degree in Computer Science from the University of Maryland. While he was an intern at J. Craig Venter Institute (JCVI), he helped to develop some of the D3 visuals for the differential analysis. He has a range of knowledge in programming languages such as JavaScript, Java and Python.",
      },
      {
        imageName: "Nikhil-Singh.jpg",
        image: Nikhil,
        description:
          "<b>Nikhil Singh</b> Nikhil is a Software Developer currently contributing to bioinformatics and computational projects at the J. Craig Venter Institute (JCVI), with expertise in full-stack development focused on JavaScript, Python, and AWS. He specializes in building data-driven applications and advanced visualizations with tools like Next.js, React, and D3.js, along with hands-on experience in distributed systems and cloud technologies such as AWS services. He is dedicated to developing scalable, impactful solutions through cloud integrations and is an enthusiastic contributor to open-source projects.",
      },
      {
        imageName: "Rhea-Hinger.jpg",
        image: Rhea,
        description:
          "<b>Rhea Hinger, M.A.</b> Rhea holds a Master’s in Graphic Design from the Maryland Institute College of Art. She was an intern at J. Craig Venter Institute (JCVI) where she helped with the UI-UX Design. She is skilled in communication design, wire framing and user research.",
      },
      {
        imageName: "Shubham-Deshmukh.jpg",
        image: Shubham,
        description:
          "<b>Shubham Deshmukh, B.S., M.S.</b> Shubham is a Computer Science graduate student at Virginia Tech with extensive experience in software engineering, machine learning, and data visualization. He has contributed to impactful projects such as the Human Salivary Proteome (HSP) at JCVI and developed advanced algorithms for environmental data analysis. With expertise in Python, JavaScript, React, D3.js, AWS, and Docker, Shubham is particularly passionate about data science, machine learning, and computer vision.",
      },
      {
        imageName: "Shuvrajyoti-Deb.jpg",
        image: Shuv,
        description:
          "<b>Shuvrajyoti Debroy, B.S., M.S.</b> Shuv is a Software Engineer with a masters degree in data science. During his internship, he contributed to the HSP data pipeline. He has a range of experience with machine learning, statistical analysis, and data visualization.",
      },
    ],
  },
];

export default memberInfo;
